import { useState } from 'react'
import Modal from "../Modal/Modal";
import Exclamation from "../../assets/images/Exclamation.svg";
import DocumentButton from '../DocumentButton/DocumentButton';
import { IAlert } from '../../helpers/Interfaces';

import "./ConfirmationPrompt.scss";

type ConfirmationPromptProps = {
    onClose: () => void;
    open: boolean;
    header: string;
    body: string;
    onOk: () => void;
    loading: boolean;
}

function ConfirmationPrompt(props: ConfirmationPromptProps) {

    const [showAlert, setShowAlert] = useState({} as IAlert);

    const closeAlert = () => {
        let newShowAlert = showAlert;
        newShowAlert.open = false;
        setShowAlert((prevDetails) => ({ ...prevDetails, ...newShowAlert }));
    }

    const handleClose = () => {
        props.onClose();
    }

    const handleOk = () => {
        props.onOk();
    }

    return (
        <Modal open={props.open} close={handleClose} style={'card-delete'} showAlert={showAlert}
            closeAlert={closeAlert} editable={false}>
            <div className="confirmation-prompt-container">
                <img className='confirmation-icon' src={Exclamation} alt="Confirmation" />
                <div className="content">
                    <label className='header'>{props.header}</label>
                    <label className='body'>{props.body}</label>
                </div>
                <div className="footer">
                    <span onClick={handleClose} className="cancel">Cancel</span>
                    <DocumentButton backgroundColor='#eb6d26' text={'Yes'} onClick={handleOk} loading={props.loading} />
                </div>
            </div>
        </Modal>
    )
}

export default ConfirmationPrompt